module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-anchor-links/gatsby-browser.js'),
      options: {"plugins":[],"offset":-140},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-MHCJEWF70Y"]},
    },{
      plugin: require('../node_modules/gatsby-plugin-parsely-analytics/gatsby-browser.js'),
      options: {"plugins":[],"apikey":"montanafreepress.org","enableInDevelopment":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Laws on trial – Montana Capitol lawsuit tracker","short_name":"Laws on trial","description":"Multiple legal challenges have been filed against measures passed by the 2021 Montana Legislature. Here’s where each case stands.","start_url":"/","icon":"static/mtfp-icon.png","background_color":"#eae3da","theme_color":"#F85028","display":"standalone","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"0027fdc022495653bd2c7bc2671d20a2"},
    }]
